module.exports = "/_next/static/images/associationLogo10-2efe3c50f927667567bf0630e8dfb735.webp";